var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDarkLimitOrderArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#363970"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1173 20.2478C14.4258 20.2478 14.0413 21.0477 14.4733 21.5878L19.3555 27.6905C19.6856 28.1032 20.3134 28.1032 20.6435 27.6905L25.5257 21.5878C25.9577 21.0477 25.5732 20.2478 24.8816 20.2478H23.2202C22.7965 20.2478 22.4417 19.9267 22.3995 19.505L21.7976 13.4854C21.7133 12.6422 21.0037 12 20.1562 12L19.8428 12C18.9953 12 18.2857 12.6422 18.2014 13.4854L17.5994 19.505C17.5573 19.9267 17.2025 20.2478 16.7788 20.2478H15.1173Z",
    fill: "#232345"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 36,
    height: 36,
    rx: 18,
    stroke: "#232345",
    strokeWidth: 4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDarkLimitOrderArrow);
export default __webpack_public_path__ + "static/media/darkLimitOrderArrow.81b47e0ae7ed28872647df74fc23e2bc.svg";
export { ForwardRef as ReactComponent };